import * as React from "react";
import { AlertCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CrashFallbackProps {
  resetError: () => void;
}

// Fallback do Error Boundary raiz (App.tsx). Erro de render não tratado (ex.: crash
// de biblioteca de terceiro) cai aqui em vez de derrubar a árvore inteira em silêncio.
export function CrashFallback({ resetError }: CrashFallbackProps): React.ReactElement {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
      <AlertCircle className="h-8 w-8 text-rd-danger-700" />
      <h1 className="text-[16px] font-semibold text-text-primary">Algo deu errado</h1>
      <p className="max-w-sm text-[13px] text-text-secondary">
        Encontramos um erro inesperado nesta tela. Recarregue a página para continuar.
      </p>
      <Button
        size="sm"
        onClick={() => {
          resetError();
          window.location.reload();
        }}
      >
        Recarregar página
      </Button>
    </div>
  );
}
